module.exports = __webpack_public_path__ + "img/bolton.65cf0430.jpg";